import chatIcon from "../Assets/icons/Group 1716.svg";
import cancelIcon from "../Assets/icons/cancel.png";
import chatBotIcon from "../Assets/icons/Group 1716.svg";
import botImageUrl2 from "../Assets/icons/Group 32 (1).svg";
import botImageUrl from "../Assets/account_circle.svg";
import bgImage from "../Assets/bg.jpg"

export const REPLY_MESSAGE =
  "I apologize, but I am unable to find any relevant information for your query. Please try rephrasing your question or providing more details.";

export const GREETING_MESSAGE = "Hello! How can I assist you today?";

export const HEADING = "CHATBOT";
export const HEADING2 = ""; 
export const CHATBOT_HEADING = "Mahindra";
export const CHATBOT_SUBHEADING = "ChatBot";
export const HEADING_TEXT_COLOUR = "White";

export const INTRO_MESSAGE = "";

// export const INITIAL_MESSAGES = ["How can I download this app?" , "What's special about this app?", "Is this a paid app?"];

export const FORM_QUESTION_LENGTH = 1;

export const CHATBOT_BETA_MESSAGE = " Chatbot is in Beta. Verify chatbot information for accuracy.";

export const GREETINGS = [
  "hi",
  "hi?",
  "hello",
  "hey",
  "hi there",
  "hello there",
  "hey there",
  "hi, there",
  "hello, there",
  "hey, there",
  "howdy",
  "greetings",
  "what's up",
  "how are you?",
  "good day",
  "yo",
  "hiya",
  "sup",
  "wassup",
];

export const ASSETS = { chatBotIcon, chatIcon, cancelIcon };

export const WIDGET_DEFAULT_VALUES = {
  campaignId: 'NA',
  campaignName: 'NA',
  campaignSubDomain: 'NA',
  header: {
    height: '2.5rem',
    backgroundColor: '#EB3F2C',
    logo: {
      height: '28px',
      width: '75px',
      imageUrl: chatBotIcon,
    },
    heading: {
      text: HEADING,
      fontSize: '9px',
      fontColor: HEADING_TEXT_COLOUR,
      fontFamily: 'Montserrat',
    },
    subHeading: {
      text: HEADING2,
      fontSize: '14px',
      fontColor: 'white',
      fontFamily: 'normal normal bold 10px Montserrat',
    },
  },
  azureOpenAI: {
    baseUrl: "string",
    searchKey: "string",
    openaiKey: "string",
    searchEndPoint: "string",
    indexName: "string"
  },
  body: {
    leadQuestionNumber: 0,
    leadFields:{
      fullName: 'True',
      email: 'True',
      mobile: 'True'
    },
    background: {
      type: 'color',
      imageUrl: bgImage,
      color: '#eee',
    },
    introductionMessageBox: {
      text: INTRO_MESSAGE,
      fontSize: 'inherit',
      fontColor: '#4A4A4A',
      fontFamily: 'inherit',
      backgroundColor: '#FFFFFF',
    },
    questionBox: {
      avatar: {
        type: 'image',
        imageUrl: botImageUrl,
        color: 'NAO',
      },
      backgroundColor: "#0F203F",
      fontColor: "#FFFFFF",
      fontFamily: 'inherit',
      fontSize: 'inherit'
    },
    answerBox: {
      avatar: {
        type: 'image',
        imageUrl: botImageUrl2,
        color: 'NAO',
      },
      backgroundColor: '#FFFFFF',
      fontColor: "#4A4A4A",
      fontFamily: 'inherit',
      fontSize: 'inherit'
    },
    initialQuestions: {
      backgroundColor: 'white',
      fontSize: 'inherit',
      fontColor: '#0082E2',
      fontFamily: 'inherit',
      questions: [
        
      ],
    },
    campaignImageUrl:""
  },
  footer: {
    height: 'NA',
    borderRadius: 'NA',
    placeholder: 'Type here...',
    sendButton: {
      text: 'Send',
      color: "#EB3F2C",
      borderRadius: 'NA',
      fontSize: 'inherit',
      fontFamily: 'inherit',
    },
  },
};